import React from "react";
import Header from "../Header/Header";
import "./Hero.css";
import { Link } from "react-scroll";

import NumberCounter from "number-counter";
import { motion } from "framer-motion";
import heart from "../../assets/heart.png";
import stepIcon from "../../assets/stepIcon.png";
import hero_image0 from "../../assets/compressed_hero_image0.png";
// import hero_image1 from "../../assets/hero_image1.png"
import hero_image2 from "../../assets/compressed_hero_image2.png";
import hero_image_back1 from "../../assets/hero_image_back1.png";
import hero_image_back2 from "../../assets/hero_image_back2.png";
import calories from "../../assets/calories.png";

const Hero = () => {
  const transition = { type: "spring", duration: 3 };
  const mobile = window.innerWidth <= 768 ? true : false;
  return (
    <div className="hero" id="home">
      <div className="blur hero-blur"></div>
      <div className="left-h">
        <Header />
        {/* the best ad */}
        <div className="the-best-ad">
          <motion.div
            initial={{ left: mobile ? "178px" : "238px" }}
            whileInView={{ left: "8px" }}
            transition={{ ...transition, type: "tween" }}
          />
          <span>The best fitness club in the town</span>
        </div>
        {/* Hero Heading */}
        <div className="hero-text">
          <div>
            <span className="stroke-text">Shape </span>
            <span>Your</span>
          </div>
          <div>
            <span>Ideal body</span>
          </div>
          <div className="span">
            <span>
              In Here we will help you to shape and build your ideal body and
              live up your life.
            </span>
          </div>
        </div>
        {/* figures */}
        <div className="figures">
          <div>
            <span>
              <NumberCounter end={10} start={0} delay="4" preFix="+" />
            </span>
            <span>Years Experieance</span>
          </div>
          <div>
            <span>
              <NumberCounter end={108} start={0} delay="4" preFix="+" />
            </span>
            <span>Members Joined</span>
          </div>
          <div>
            <span>
              <NumberCounter end={50} start={1} delay="1" preFix="+" />
            </span>
            <span>fitness Programs</span>
          </div>
        </div>
        {/* hero buttons */}
        <div className="hero-buttons">
          <button className="btn">
            <Link
              activeClass="active"
              to="programs"
              spy={true}
              smooth={true}
              offset={-40}
              duration={500}
            >
              Get Started
            </Link>
          </button>
          <button className="btn">
            <Link
              activeClass="active"
              to="reasons"
              spy={true}
              smooth={true}
              offset={-40}
              duration={500}
            >
              Learn More
            </Link>
          </button>
        </div>
      </div>
      <div className="right-h">
        <button className="btn">
          <Link
            activeClass="active"
            to="plans"
            spy={true}
            smooth={true}
            offset={-30}
            duration={500}
          >
            Join Now
          </Link>
        </button>
        <motion.div
          initial={{ right: "-1rem" }}
          whileInView={{ right: "4rem" }}
          transition={transition}
          className="heart-rate"
        >
          <img src={heart} alt="" />
          <span>Heart Rate</span>
          <span>
            <NumberCounter
              end={50}
              start={1}
              delay="1"
              preFix=""
              postFix="bpm"
            />
          </span>
        </motion.div>
        <motion.div
          initial={{ right: "-1rem" }}
          whileInView={{ right: "4rem" }}
          transition={transition}
          className="step-counter"
        >
          <img src={stepIcon} alt="Step Icon" />
          <span>Steps</span>
          <span>
            <NumberCounter end={26410} start={24000} delay="0.1" preFix="" />
          </span>
        </motion.div>
        {/* hero image */}
        <img src={hero_image0} alt="" className="hero-image0" />
        {/* <img src={hero_image1} alt="" className="hero-image1" /> */}
        <img src={hero_image2} alt="" className="hero-image2" />
        <motion.img
          initial={{ right: "11rem" }}
          whileInView={{ right: "27rem" }}
          transition={transition}
          src={hero_image_back1}
          alt=""
          className="hero-image-back1"
        />
        <motion.img
          initial={{ right: "11rem" }}
          whileInView={{ right: "21rem" }}
          transition={transition}
          src={hero_image_back2}
          alt=""
          className="hero-image-back2"
        />

        {/* calories */}
        <motion.div
          initial={{ right: "30rem" }}
          whileInView={{ right: "28rem" }}
          transition={transition}
          className="calories"
        >
          <img src={calories} alt="" />
          <div>
            <span>Calories Burned</span>
            <span>
              <NumberCounter
                end={220}
                start={1}
                delay="1"
                preFix=""
                postFix="kcal"
              />
            </span>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Hero;
